import * as sounds from '../../constants/Sounds'

var library = [
    {
        key: sounds.LOOP,
        files: [
            { path: "./sounds/loop.wav", volume: 0.6 }
        ]
    },
    {
        key: sounds.GOAL_AWAY,
        files: [
            { path: "./sounds/crowd_upset1.wav" },
            { path: "./sounds/crowd_upset2.wav" },
            { path: "./sounds/crowd_upset3.wav" },
            { path: "./sounds/crowd_upset4.wav" },
            { path: "./sounds/crowd_upset5.wav" }
        ]
    },
    {
        key: sounds.GOAL_HOME,
        files: [
            { path: "./sounds/crowd_goal.wav" }
        ],
        overrides: [{
            teamId: 1,
            files: [
                { path: "./sounds/train5.wav" }
            ],
        }]
    },
    {
        key: sounds.SHORT_PASS,
        files: [
            { path: "./sounds/short_pass.wav" }
        ]
    },
    {
        key: sounds.LONG_PASS,
        files: [
            { path: "./sounds/long_pass.wav" }
        ]
    },
    {
        key: sounds.GK_KICK,
        files: [
            { path: "./sounds/gk_kick.wav" }
        ]
    },
    {
        key: sounds.SHOT,
        files: [
            { path: "./sounds/shot.wav" }
        ]
    },
    {
        key: sounds.GAME_END,
        files: [
            { path: "./sounds/ref_end.wav" }
        ]
    },
    {
        key: sounds.REF,
        files: [
            { path: "./sounds/ref.wav" }
        ]
    },
    {
        key: sounds.NEAR_MISS,
        files: [
            { path: "./sounds/crowd_near_miss2.wav" }
        ]
    },
    {
        key: sounds.Ohh,
        files: [
            { path: "./sounds/crowd_ooh7.wav" }
        ]
    },
    {
        key: sounds.AWAY_MISS,
        files: [
            { path: "./sounds/crowd_near_miss1.wav" }
        ]
    },
    {
        key: sounds.REF_HALFTIME,
        files: [
            { path: "./sounds/ref_halftime.wav" }
        ]
    },
    {
        key: sounds.REF_START,
        files: [
            { path: "./sounds/ref_start.wav" }
        ]
    }
]

export default class SoundLibrary {
    constructor(homeId, awayId, attendance) {
        this.initWith(library);
        this.homeId = homeId;
        this.awayId = awayId;
        this.attendance = attendance;
    }

    initWith(library) {
        this.library = library;
    }

    _getSoundObj(key) {
        for (let index = 0; index < this.library.length; index++) {
            let s = this.library[index];
            if(s.key == key)  
                return s;
        }
    }

    _getFileNameFromPath(path) {
        return path.replace('./sounds/', '');
    }

    GetSoundUrl(id) {
        let soundObj = this._getSoundObj(id);
        if(soundObj == null)
            throw 'unknown sound ' + id

        return soundObj.files[0].path;
    }

    _getOverridenFiles(soundObj, home) {
        if(home == null)
            return [];

        let teamId = home ? this.homeId : this.awayId;

        if(soundObj.overrides != null) {
            for (var index = 0; index < soundObj.overrides.length; index++) {
                var overrides = soundObj.overrides[index];
                if(overrides.teamId == teamId)
                    return overrides.files;
            }
        }

        return [];
    }

    _getCustomProbability(fileInfo, defaultVal) {
        return fileInfo.probability == null ? defaultVal : fileInfo.probability
    }

    _getCustomVolume(fileInfo) {
        return fileInfo.volume == null ? 1 : fileInfo.volume
    }

    _filterWithCustomConditions(files) {
        let result = [];
        for (var index = 0; index < files.length; index++) {
            var file = files[index];
            if(file.condition != null && file.condition != '') {
                if(eval(file.condition))
                    result.push(file);
            }
            else
                result.push(file);
            
        }

        return result;
    }

    _getProbabilitySum(files) {
        let res = 0;
        files.forEach(function(file) {
            res += file.probability != null ? file.probability : 1/files.length
        }, this);

        return res;
    }

    RequestSound(key, home = null, skipCustomConditions = false, includeFilePath = false) {
        let soundObj = this._getSoundObj(key)
        let files = this._getOverridenFiles(soundObj, home);
        if(files == null || files.length == 0)
            files = soundObj.files;

        files = skipCustomConditions == true ? files : this._filterWithCustomConditions(files);
        let probabilitySum = this._getProbabilitySum(files);
        
        let result = [];
        for (var index = 0; index < files.length; index++) {
            var fileInfo = files[index];
            let customProbability = this._getCustomProbability(fileInfo, probabilitySum/files.length);
            result.push({
                id: key + '_' + this._getFileNameFromPath(fileInfo.path),
                probability: customProbability/probabilitySum,
                volume: this._getCustomVolume(fileInfo)
            });
            if(includeFilePath == true)
                result[result.length-1].path = fileInfo.path;
        }
        
        return result;
    }

    GetFileListForInitialDownload() {
        let result = [];

        function idExists(id) {
            for (var index = 0; index < result.length; index++) {
                var element = result[index];
                if(element.id == id)
                    return true;                
            }

            return false;
        }
        
        for (var index = 0; index < this.library.length; index++) {
            let soundDefinition = this.library[index];
            let homeSoundRequestResult = this.RequestSound(soundDefinition.key, true, true, true);
            let awaySoundRequestResult = this.RequestSound(soundDefinition.key, false, true, true);

            let addToResult = (fileInfo) => {
                if(!idExists(fileInfo.id))
                    result.push({
                        id: fileInfo.id,
                        path: fileInfo.path
                    })
            }
            
            homeSoundRequestResult.forEach(addToResult);
            awaySoundRequestResult.forEach(addToResult);
        }

        return result;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Sound/SoundLibrary.js
 **/